import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import accounting from './modules/accounting'
import notification from './modules/notification'
import party from './modules/party'
import user from './modules/user'
import ui from './modules/ui'
import cashbank from './modules/cashbank'
import employee from './modules/employee'
import vendor from './modules/vendor'
import expense from './modules/expense'
import payment from './modules/payment'
import category from './modules/category'
import salary from './modules/salary'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    auth,
    notification,
    accounting,
    party,
    user,
    ui,
    cashbank,
    employee,
    vendor,
    expense,
    payment,
    category,
    salary
  }
})
